module.exports = __webpack_public_path__ + "img/product-placeholder-54.e43e922.png";